import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {SpinnerButton} from "../../SpinnerButton";
import { withTranslation } from 'react-i18next';

class AddKlaviyoAccountFormClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apiKey: '',
            loading: false,
            error: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        const { t } = this.props;
        const apiKey = this.state.apiKey.trim();

        if (!apiKey) {
            this.setState({ error: t('klaviyo.api_key_required') });
            return;
        }

        this.setState({ loading: true, error: null });

        new APIClient(API_URL + 'get_access_tokens/klaviyo/').call('POST', {
            api_key: apiKey,
        }).then((response) => {
            if (response.status === 'ERROR') {
                this.setState({ loading: false, error: response.error_message });
            } else {
                this.setState({ loading: false });
                this.props.afterSuccessfulSubmit(response.data);
            }
        }).catch(() => {
            this.setState({
                loading: false,
                error: t('klaviyo.connection_error'),
            });
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <ModalBody>
                    <div className="modal-section">
                        <p>{t('klaviyo.connect_description')}</p>
                        <div className="form-row">
                            <label>{t('klaviyo.api_key_label')}</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('klaviyo.api_key_placeholder')}
                                value={this.state.apiKey}
                                onChange={(e) => this.setState({ apiKey: e.target.value, error: null })}
                            />
                        </div>
                        <div className="alert alert-info" style={{ fontSize: '0.9em', marginTop: '1em', marginBottom: 0 }}>
                            {t('klaviyo.api_key_help')}
                        </div>
                        {this.state.error && (
                            <div className="alert alert-danger" style={{ fontSize: '0.9em', marginTop: '1em', marginBottom: 0 }}>
                                {this.state.error}
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.state.loading ? (
                        <SpinnerButton />
                    ) : (
                        <button
                            className="btn -alt"
                            onClick={this.handleSubmit}
                        >
                            {t('klaviyo.connect_button')}
                        </button>
                    )}
                </ModalFooter>
            </div>
        );
    }
}

export const AddKlaviyoAccountForm = withTranslation()(AddKlaviyoAccountFormClass);
